import React from "react";
import styled from "styled-components";
import { useState, useLayoutEffect } from "react";

import noLiveCameraPlaceholderSrc from "assets/images/no-live-image.png";
import Icon from 'components/Icon';

const LiveCamera = ({
  doorName,
  statusColor,
  img,
  previousDoor,
  previousStatusColor,
  isBorderOnly,
  previousIsBorderOnly,
  isStorageEquipment,
  previousIsStorageEquipment,
  percentComplete,
  unloadMethod,
  direction,
  ...rest
}) => {
  const [hasImageRendered, setHasImageRendered] = useState(false);

  useLayoutEffect(() => {
    setHasImageRendered(false);
  }, [doorName]);
  const isOnline = navigator.onLine;

  const { searchParams: queryParams } = new URL(window.location.href);
  const debugMode = queryParams.get('debugMode');

  const activeColor = hasImageRendered ? statusColor : previousStatusColor;
  const activeDoorName = hasImageRendered ? doorName : previousDoor;
  const activeIsBorderOnly = hasImageRendered ? isBorderOnly : previousIsBorderOnly;
  const activeIsStorageEquipment = hasImageRendered ? isStorageEquipment : previousIsStorageEquipment;

  return (
    <LiveCameraWrapper {...rest}>
      <LiveCameraStatus
        color={activeColor}
        variant={activeIsBorderOnly ? 'border' : 'filled'}
        isStorageEquipment={activeIsStorageEquipment}
      >
        <div>
          {activeDoorName}{' '}
          <small>
            {debugMode === 'true' && unloadMethod != null
              ? ' | ' +
                unloadMethod +
                ' ' +
                direction +
                ' ' +
                parseInt((percentComplete === null ? 0 : percentComplete) * 100) +
                '%'
              : ''}
          </small>
        </div>
        {activeIsStorageEquipment && (
          <Icon
            name="archive"
            size="1.2vw"
            color="#232526"
            strokeWidth={2}
          />
        )}
      </LiveCameraStatus>
      {isOnline ? (
        <LiveCameraImage
          onLoad={() => {
            setHasImageRendered(true);
          }}
          src={img || noLiveCameraPlaceholderSrc}
          onError={(e) => {
              e.target.src = noLiveCameraPlaceholderSrc;
          }}
        />
      ) : (
        <NoInternetTextContainer>
          No internet connection
        </NoInternetTextContainer>
      )}
    </LiveCameraWrapper>
  );
};

const LiveCameraWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #eff2f5;
  background-clip: content-box;
  border-radius: 8px;
  overflow: hidden;
`;

const LiveCameraStatus = styled.div`
  width: 100%;
  min-height: 15%;
  box-sizing: border-box;
  font-weight: 600;
  font-size: 1.35vw;
  line-height: 2.7vw;

  color: ${(props) => (props.isStorageEquipment ? '#232526' : (props.variant === 'border' ? props.color : '#fff'))};
  background-color: ${(props) => (props.isStorageEquipment ? '#ffffff' : (props.variant === 'border' ? '#fff' : props.color))};

  box-shadow: ${(props) =>
    props.isStorageEquipment
      ? 'none'
      : props.variant === 'border'
      ? `inset 0 0 0 0.25vw ${props.color}`
      : 'none'};

  border-radius: 8px 8px 0 0;

  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 5%;
`;

const LiveCameraImage = styled.img`
  width: 100%;
  max-width: 100%;
  border-radius: 0 0 8px 8px;
`;
const NoInternetTextContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  font-size: 1.5rem;
`;
export default LiveCamera;
